import React, { useRef, useEffect } from 'react'
import ReactDom from 'react-dom'


const ModalOverlay = (props) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        props.setTrigger(false);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, []); // <--- important!

  return props.trigger ? (
    <div
      ref={modalRef}
      className="position-fixed rounded bg-transparent"
      style={{
        zIndex: 200,
        right: props.right,
        top: props.top
      }}
      onPointerDown={(e) => {
        e.stopPropagation();
      }}
    >
      {props.content}
    </div>
  ) : null;
};


const Modal = (props) => {
    
  return (
    <>
      {ReactDom.createPortal(
        <ModalOverlay
          content = {props.content}
          trigger = {props.trigger}
          setTrigger = {props.setTrigger}
          top = {props.top}
          right = {props.right}
        />,
        document.getElementById('overlay-root')
        )
      }
    </>
  )
}

export default Modal
